import { postJson } from "../../../core/http";

export function createPaypalPayment({ productCode, productType } = {}) {
  return postJson("/api/v1/payments/paypal/create", {
    product_code: productCode,
    product_type: productType,
  });
}

export function capturePaypalPayment({ providerId } = {}) {
  return postJson("/api/v1/payments/paypal/capture", {
    provider_id: providerId,
  });
}
